// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Layout
import BaseLayout from "../BaseLayout";

export default class LoginLayout extends React.Component {
	public render() {
		const { children } = this.props;

		return (
			<>
				<div className="loginLayoutContainer">
					<div className="loginLayoutContainerChildrenContainer">
						{children}
					</div>
				</div>
				<BaseLayout />
			</>
		);
	}
}
